import { ApiValidationErrorContract } from '../../types/Errors';

class ApiValidationError extends Error {
  public errors: ApiValidationErrorContract[];

  public readonly isValidationError = true;

  constructor(message: string, validationErrors: ApiValidationErrorContract[]) {
    super();
    this.errors = validationErrors;
    this.message = message;
  }

  public extractErrorMessages = (): string[] => {
    return this.errors.reduce((acc: string[], fieldError) => {
      return acc.concat(fieldError.messages);
    }, []);
  };
}

export default ApiValidationError;
